module.exports = __webpack_public_path__ + "src/img/zalando/img-stack.0e395.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/zalando/img-stack.jpg
// module id = 268
// module chunks = 0